import React, { useEffect } from 'react';
import { getSessionStorage, setSessionStorage } from '../common/common';

const ServiceAttendance = ({ type, id }) => {
  const behaviourObjects = () =>
    getSessionStorage('attendance_objects', false)
      ? JSON.parse(getSessionStorage('attendance_objects', '[]'))
      : [];
  const getUserGoal = () =>
    getSessionStorage('user_goal', false) ? JSON.parse(getSessionStorage('user_goal', '{}')) : {};
  const getGoalAchieved = () =>
    getSessionStorage('goal_achieved', false)
      ? JSON.parse(getSessionStorage('goal_achieved', '{}'))
      : {};
  useEffect(() => {
    console.log('BEHAVIOUR_OBJECTS_FROM_ATTENDANCE', behaviourObjects());
    if (!behaviourObjects()?.some((_obj) => _obj.id == id)) {
      let userGoal = getUserGoal();
      let goalAchieved = getGoalAchieved();
      console.log('USER_GOAL', userGoal);
      console.log('GOAL_ACHIEVED', goalAchieved);
      // 1 for medwiki 2 for clinical video and 3 for session
      switch (type) {
        case 1:
          if (goalAchieved?.article_read) {
            goalAchieved.article_read.total_goal =
              (goalAchieved?.article_read?.total_goal || 0) + 1;
          } else {
            goalAchieved.article_read = {
              total_goal: 1
            };
          }
          console.log('INSIDE_ARTICLE_READ', goalAchieved?.article_read?.total_goal, userGoal.read);
          if (goalAchieved?.article_read?.total_goal >= 10) {
            userGoal?.read ? (userGoal.read += 10) : (userGoal.read = 10);
          }
          break;
        case 2:
          if (goalAchieved?.video_watched) {
            goalAchieved.video_watched.total_goal =
              (goalAchieved?.video_watched?.total_goal || 0) + 1;
          } else {
            goalAchieved.video_watched = {
              total_goal: 1
            };
          }
          if (goalAchieved?.video_watched?.total_goal >= 10) {
            userGoal?.watch ? (userGoal.watch += 10) : (userGoal.watch = 10);
          }
          break;
        case 3:
          if (goalAchieved?.attended_cme) {
            goalAchieved.attended_cme.total_goal =
              (goalAchieved?.attended_cme?.total_goal || 0) + 1;
          } else {
            goalAchieved.attended_cme = {
              total_goal: 1
            };
          }
          if (goalAchieved?.attended_cme?.total_goal >= 10) {
            userGoal?.attend ? (userGoal.attend += 10) : (userGoal.attend = 10);
          }
          break;

        default:
          break;
      }
      setSessionStorage('user_goal', JSON.stringify(userGoal));
      setSessionStorage('goal_achieved', JSON.stringify(goalAchieved));

      let obj = {
        id,
        type
      };

      let array_to_store =
        behaviourObjects() && behaviourObjects()?.length > 0 ? [...behaviourObjects(), obj] : [obj];

      setSessionStorage('attendance_objects', JSON.stringify(array_to_store));
    }
  }, []);
  return <></>;
};

export default ServiceAttendance;
